import * as React from 'react';

function SvgCalendar3Fill(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M0 2a2 2 0 012-2h12a2 2 0 012 2H0zm0 1v11a2 2 0 002 2h12a2 2 0 002-2V3H0z' />
		</svg>
	);
}

export default SvgCalendar3Fill;
